import React from 'react'
import { Link,useLocation } from 'react-router-dom';
import {ReactComponent as HomeIcon} from '../../images/icons/Dashboard.svg'
import {ReactComponent as BookmarksIcon} from '../../images/icons/Bookmark_Active.svg'
import {ReactComponent as ListingIcon} from '../../images/icons/Listing.svg'
import {ReactComponent as HeartIcon} from '../../images/icons/like.svg'
import {ReactComponent as HelpIcon} from '../../images/icons/Setting.svg'
import {ReactComponent as InsighsIcon} from '../../images/icons/Insight.svg'
import {ReactComponent as OrdersIcon} from '../../images/icons/Orders.svg'
import {ReactComponent as SalesIcon} from '../../images/icons/Sales.svg'
import {ReactComponent as KeyIcon} from '../../images/icons/key.svg'
import {ReactComponent as MessageIcon} from '../../images/icons/MessageChat.svg'
import ApiUrl from '../../configTools/apiUrl'

import Button from '../../components/forms/blackfillButton';

const Sidebar = ({User}) => {
    const currentRoute = useLocation().pathname.toLowerCase();
    const showPreview = (e) =>{
        if(e.target.files && e.target.files[0]){
            let imageFile = e.target.files[0];
            const formData = new FormData();
            formData.append("file",imageFile);
            fetch(ApiUrl.API_URL_File, {
                method: 'POST',
                body: formData
            })
            .then(res=>res.json())
            .then(data =>{
                if(data.success){
                    fetch(ApiUrl.Profile, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer '+User.token
                        },
                        body: JSON.stringify({
                            Id:User.id,
                            discription: User.discription,
                            firstname : User.firstname,
                            lastname : User.lastname,
                            address : User.address,
                            cnic : User.cnic,
                            contact : User.contact,
                            email : User.email,
                            location : User.location,
                            image : data.url
                        })
                      })
                      .then(res2=>res2.json())
                      .then(data2 =>{
                        if(data2.success){
                            let userNew = User;
                            userNew.image = data.url;
                            localStorage.setItem("user-info",JSON.stringify(userNew));
                            document.location.reload();
                        }
                        else{
                            console.log(data2.responce);
                        }
                    });
                }
                else{
                    console.log(data.responce);
                }
            });
        }
    }
  return (
    <div className='dashboard_siderbar_wrapper'>
      <div className='dashboard_siderbar_container'>
        <div className='dashboard_siderbar_profile_container'>
            <div className='dashboard_siderbar_profile_image'>
                <label style={{cursor:"pointer"}}>
                    <div style={{
                        width: "100%",
                        paddingTop: "80%",
                        borderRadius: "10px",
                        position: "relative",
                        backgroundImage:`url(${ApiUrl.API_URL_Image_Collection+User.image})`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        
                    }}>
                    <input type="file" style={{display:"none"}} onChange={showPreview}/>
                    </div>
                </label>
            </div>
            <div className='dashboard_siderbar_profile_details'>
                <h3>{User.firstname} {User.lastname}</h3>
                <h4>@{User.username}</h4>
            </div>
            <div className='dashboard_siderbar_profile_button'>
                <Link to={'/dashboard/editprofile'}>
                    <Button Value='Edit Profile' />
                </Link>
            </div>
        </div>
        <Link to={'/dashboard/index'}>
            <div className={currentRoute.includes('dashboard/index')? "dashboard_sidebar_menuitem_container active" : "dashboard_sidebar_menuitem_container"}>
                <div className='dashboard_sidebar_menuitem_border'></div>
                <div className='dashboard_sidebar_menuitem_icon'>
                    {currentRoute.includes('dashboard/index') &&
                        <HomeIcon fill='#2a2a2a' width={'20px'} height={'20px'}/>
                    }
                    {!currentRoute.includes('dashboard/index') &&
                        <HomeIcon fill='#6D7175' width={'20px'} height={'20px'}/>
                    }
                </div>
                <div className='dashboard_sidebar_menuitem_text'>
                    <h6>Dashboard</h6>
                </div>
            </div>
        </Link>
        <Link to={'/dashboard/messages'}>
            <div className={currentRoute.includes('dashboard/messages')? "dashboard_sidebar_menuitem_container active" : "dashboard_sidebar_menuitem_container"}>
                <div className='dashboard_sidebar_menuitem_border'></div>
                <div className='dashboard_sidebar_menuitem_icon'>
                    {currentRoute.includes('dashboard/messages') &&
                        <MessageIcon fill='#2a2a2a' width={'20px'} height={'20px'}/>
                    }
                    {!currentRoute.includes('dashboard/messages') &&
                        <MessageIcon fill='#6D7175' width={'20px'} height={'20px'}/>
                    }
                </div>
                <div className='dashboard_sidebar_menuitem_text'>
                    <h6>Messages</h6>
                </div>
            </div>
        </Link>
        <Link to={'/dashboard/liked'}>
            <div className={currentRoute.includes('dashboard/liked')? "dashboard_sidebar_menuitem_container active" : "dashboard_sidebar_menuitem_container"}>
                <div className='dashboard_sidebar_menuitem_border'></div>
                <div className='dashboard_sidebar_menuitem_icon'>
                    {currentRoute.includes('dashboard/liked') &&
                        <HeartIcon fill='#2a2a2a' width={'20px'} height={'20px'}/>
                    }
                    {!currentRoute.includes('dashboard/liked') &&
                        <HeartIcon fill='#6D7175' width={'20px'} height={'20px'}/>
                    }
                </div>
                <div className='dashboard_sidebar_menuitem_text'>
                    <h6>Liked</h6>
                </div>
            </div>
        </Link>
        <Link to={'/dashboard/bookmarks'}>
            <div className={currentRoute.includes('dashboard/bookmarks')? "dashboard_sidebar_menuitem_container active" : "dashboard_sidebar_menuitem_container"}>
                <div className='dashboard_sidebar_menuitem_border'></div>
                <div className='dashboard_sidebar_menuitem_icon'>
                    {currentRoute.includes('dashboard/bookmarks') &&
                        <BookmarksIcon fill='#2a2a2a' width={'20px'} height={'20px'}/>
                    }
                    {!currentRoute.includes('dashboard/bookmarks') &&
                        <BookmarksIcon fill='#6D7175' width={'20px'} height={'20px'}/>
                    }
                </div>
                <div className='dashboard_sidebar_menuitem_text'>
                    <h6>Bookmarks</h6>
                </div>
            </div>
        </Link>
        <Link to={'/dashboard/listings'}>
            <div className={currentRoute.includes('dashboard/listing')? "dashboard_sidebar_menuitem_container active" : "dashboard_sidebar_menuitem_container"}>
                <div className='dashboard_sidebar_menuitem_border'></div>
                <div className='dashboard_sidebar_menuitem_icon'>
                    {currentRoute.includes('dashboard/listing') &&
                        <ListingIcon fill='#2a2a2a' width={'20px'} height={'20px'}/>
                    }
                    {!currentRoute.includes('dashboard/listing') &&
                        <ListingIcon fill='#6D7175' width={'20px'} height={'20px'}/>
                    }
                </div>
                <div className='dashboard_sidebar_menuitem_text'>
                    <h6>Listing</h6>
                </div>
            </div>
        </Link>
        <Link to={'/dashboard/orders'}>
            <div className={currentRoute.includes('dashboard/orders')? "dashboard_sidebar_menuitem_container active" : "dashboard_sidebar_menuitem_container"}>
                <div className='dashboard_sidebar_menuitem_border'></div>
                <div className='dashboard_sidebar_menuitem_icon'>
                    {currentRoute.includes('dashboard/orders') &&
                        <OrdersIcon fill='#2a2a2a' width={'20px'} height={'20px'}/>
                    }
                    {!currentRoute.includes('dashboard/orders') &&
                        <OrdersIcon fill='#6D7175' width={'20px'} height={'20px'}/>
                    }
                </div>
                <div className='dashboard_sidebar_menuitem_text'>
                    <h6>Orders</h6>
                </div>
            </div>
        </Link>
        <Link to={'/dashboard/sales'}>
            <div className={currentRoute.includes('dashboard/sales')? "dashboard_sidebar_menuitem_container active" : "dashboard_sidebar_menuitem_container"}>
                <div className='dashboard_sidebar_menuitem_border'></div>
                <div className='dashboard_sidebar_menuitem_icon'>
                    {currentRoute.includes('dashboard/sales') &&
                        <SalesIcon fill='#2a2a2a' width={'20px'} height={'20px'}/>
                    }
                    {!currentRoute.includes('dashboard/sales') &&
                        <SalesIcon fill='#6D7175' width={'20px'} height={'20px'}/>
                    }
                </div>
                <div className='dashboard_sidebar_menuitem_text'>
                    <h6>Sales</h6>
                </div>
            </div>
        </Link>
        <Link to={'/dashboard/insights'}>
            <div className={currentRoute.includes('dashboard/insights')? "dashboard_sidebar_menuitem_container active" : "dashboard_sidebar_menuitem_container"}>
                <div className='dashboard_sidebar_menuitem_border'></div>
                <div className='dashboard_sidebar_menuitem_icon'>
                    {currentRoute.includes('dashboard/insights') &&
                        <InsighsIcon fill='#2a2a2a' width={'20px'} height={'20px'}/>
                    }
                    {!currentRoute.includes('dashboard/insights') &&
                        <InsighsIcon fill='#6D7175' width={'20px'} height={'20px'}/>
                    }
                </div>
                <div className='dashboard_sidebar_menuitem_text'>
                    <h6>Insights</h6>
                </div>
            </div>
        </Link>
        <Link to={'/dashboard/changepassword'}>
            <div className={currentRoute.includes('dashboard/changepassword')? "dashboard_sidebar_menuitem_container active" : "dashboard_sidebar_menuitem_container"}>
                <div className='dashboard_sidebar_menuitem_border'></div>
                <div className='dashboard_sidebar_menuitem_icon'>
                    {currentRoute.includes('dashboard/changepassword') &&
                        <KeyIcon fill='#2a2a2a' width={'20px'} height={'20px'}/>
                    }
                    {!currentRoute.includes('dashboard/changepassword') &&
                        <KeyIcon fill='#6D7175' width={'20px'} height={'20px'}/>
                    }
                </div>
                <div className='dashboard_sidebar_menuitem_text'>
                    <h6>Password</h6>
                </div>
            </div>
        </Link>
        <Link to={'/dashboard/help'}>
            <div className={currentRoute.includes('dashboard/help')? "dashboard_sidebar_menuitem_container active" : "dashboard_sidebar_menuitem_container"}>
                <div className='dashboard_sidebar_menuitem_border'></div>
                <div className='dashboard_sidebar_menuitem_icon'>
                    {currentRoute.includes('dashboard/help') &&
                        <HelpIcon fill='#2a2a2a' width={'20px'} height={'20px'}/>
                    }
                    {!currentRoute.includes('dashboard/help') &&
                        <HelpIcon fill='#6D7175' width={'20px'} height={'20px'}/>
                    }
                </div>
                <div className='dashboard_sidebar_menuitem_text'>
                    <h6>Help</h6>
                </div>
            </div>
        </Link>
      </div>
    </div>
  )
}

export default Sidebar
